import { Box, Typography } from '@mui/material';
import logo from '../../../assets/images/loading/logo.svg'
import { createGlobalTheme } from '../../utils/globalTheme';

const LoadingScreen = ({ text = 'Загрузка...' }) => {
    const theme = createGlobalTheme();

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                minHeight: '60vh'
            }}
        >
            <Box
                component='img'
                src={logo}
                alt='Loading logo'
                sx={{
                    width: 154,
                    height: 151,
                }}
            />
            <Box
                sx={{
                    mt: '16px',
                    position: 'relative',
                    overflow: 'hidden',
                    width: 175,
                    height: 43,
                    '@keyframes rightDot': {
                        '0%': { left: '75px' },
                        '33.333%': { left: '125px' },
                        '66.667%': { left: '125px' },
                        '100%': { left: '75px' },
                    },
                    '@keyframes leftDot': {
                        '0%': { left: '75px' },
                        '33.333%': { left: '75px' },
                        '66.667%': { left: '25px' },
                        '100%': { left: '75px' },
                    },
                    '@keyframes halo': {
                        '0%': { left: '67px', top: '1px', width: '42px', height: '42px' },
                        '33.333%': { left: '71px', top: '5px', width: '34px', height: '34px' },
                        '66.667%': { left: '75px', top: '9px', width: '26px', height: '26px' },
                        '100%': { left: '67px', top: '1px', width: '42px', height: '42px' },
                    },
                }}
            >
                <Box sx={{ position: 'absolute', top: 9, left: 75, width: 26, height: 26, background: theme.palette.primary.main, borderRadius: '9999px', animation: 'rightDot 1.8s ease-out infinite', animationDelay: '1ms' }} />
                <Box sx={{ position: 'absolute', top: 9, left: 75, width: 26, height: 26, background: theme.palette.primary.main, borderRadius: '9999px', animation: 'leftDot 1.8s ease-out infinite', animationDelay: '1ms' }} />
                <Box component="svg" viewBox="0 0 26 26" xmlns="http://www.w3.org/2000/svg" sx={{ position: 'absolute', left: 75, top: 9, width: 26, height: 26 }}>
                    <circle cx="13" cy="13" r="13" fill={theme.palette.primary.main} />
                </Box>
                <Box component="svg" viewBox="0 0 42 42" xmlns="http://www.w3.org/2000/svg" sx={{ position: 'absolute', left: 67, top: 1, width: 42, height: 42, animation: 'halo 1.8s ease-out infinite', animationDelay: '1ms' }}>
                    <circle cx="21" cy="21" r="21" fill={theme.palette.primary.main} />
                </Box>
            </Box>
            <Typography variant='body1' sx={{ mt: '40px', fontSize: '16px', fontWeight: 400, lineHeight: '22.4px' }}>{text}</Typography>
        </Box>
    )
};

export default LoadingScreen;
